<template>
	<div>
		<div v-if="tmzReport.reload == 0">
			<!-- <PageLoader /> -->
			<div>
				<EcpSign
					:xmlToSignPro="tmzReport.xmlToSign"
					:tmzId="tmzReport.id"
				/>
			</div>
			
      <div class="container sub-actions">
				<!-- <div class="container" v-if="isImpl && !tmzReport.withDigitalSign">
					<button class="table-actions-button btn-blue" v-if="isImpl && tmzReport.step === 5" @click="downloadTemplate('s6')" type="button">
						Скачать шаблон
					</button>
				</div> -->
				<button class="table-actions-button btn-blue" v-if="isImpl && !tmzReport.withDigitalSign && tmzReport.step === 5" @click="downloadTemplate('s6')" type="button">
					Скачать шаблон
				</button>
				<a :href="downloadInstructionTmz3rdStep" download v-if="tmzReport.step === 2">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 3 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz4thStep" download v-if="tmzReport.step === 3">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 4 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz5thStep" download v-if="tmzReport.step === 4">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 5 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz6thStep" download v-if="tmzReport.step === 5">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 6 шагу
          </button>
        </a>
        <button
            v-if="tmzReport.step >= 5"
            class="table-actions-button btn-green"
            type="button"
            @click="toDate()">
          Разбивка по годам
        </button>
				<button
					v-if="tmzReport.step >= 2"
					class="table-actions-button btn-green"
					type="button"
					@click="downloadUploadedFiles()"
					style="margin-left: 20px">
					Скачать загруженные файлы
				</button>
				<div class="icon" @mouseover="showInfoModal" v-if="tmzReport.step != 6">
          <div class="icon-help-color icon-circle-main"></div>
          <div class="icon-circle-sub-main">
            <div class="custom-icons-container">
              <span class="custom-icons icon-help">help</span>
            </div>
          </div>
        </div>
      </div>
			<div class="container">
				<form
					v-on:keyup.enter="getIlliquidReportRequest()"
					v-on:submit.prevent
				>
					<div class="table-filter-container">
						<model-select
							:options="this.tmcCodesFilters"
							v-model="codeTmc"
							class="table-filter-select"
							placeholder="Код ТМЦ"
						></model-select>
						<model-select
							:options="this.tmcNamingsFilters"
							v-model="tmcName"
							class="table-filter-select"
							placeholder="Наименование ТМЦ"
						></model-select>
						<button
							class="table-filter-submit"
							@click="getIlliquidReportRequest()"
						>
							Поиск
						</button>
						<button
							class="table-filter-submit"
							@click="clearFilters()"
						>
							Очистить
						</button>
					</div>
				</form>
			</div>


		<modal name="info-modal" :width="800"
         :height="450"
         :adaptive="true">
			<div class="modal-inner">
				<div class="info-modal-container">
					<div class="slider">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас вышла ошибка с минусовым значением, то вам необходимо скачать отчет сформированный на портале, далее фильтром выберите поля закрашенные красным цветом и проведите анализ по этим строкам, сравните значения из-за чего образовалась данная ошибка
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>


			<ImportFile
				:isImpl="isImpl"
				:step="tmzReport.step"
				:id="tmzReport.id"
			/>

			<StepHeader :tmzId="this.$route.params.id" :step="tmzReport.step" />

			<div class="container">
				<h2 class="text-3xl font-semibold my-6">
					Неликвид за {{ showMonth() }} {{ TMZREPORT.year }} г. "{{
						TMZREPORT.dzo.name
					}}"
				</h2>
			</div>

			<div class="table-container-inner">
				<table>
					<thead>
						<tr class="tr-fixed-height">
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								№ п/п
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								Администратор (структурное подразделение)
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								Группа товаров
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								Код ТМЦ (согласно учетной системы)
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								Наименование ТМЦ
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="3"
							>
								Ед. изм.
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="2"
								colspan="4"
							>
								Остатки за предыдущие фин.годы
							</th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="1"
								colspan="9"
							></th>
							<th
								class="metall-received-count"
								scope="col"
								rowspan="2"
								colspan="2"
							>
								Остаток на конец отчетного месяца
							</th>
						</tr>
						<tr>
							<th colspan="2">Поступило ТМЦ</th>
							<th colspan="3">Реализовано/Списано</th>
							<th colspan="2">
								Переведено в категорию металлолом
							</th>
							<th colspan="2">
								Переведено в категорию утилизирован
							</th>
						</tr>
						<tr>
							<th>Дата поступления</th>
							<th>Кол-во</th>
							<th>Цена</th>
							<th>Сумма</th>
							<th>Кол-во</th>
							<th>Сумма</th>
							<th>Кол-во</th>
							<th>Сумма</th>
							<th>Виды реализации</th>
							<th>Кол-во</th>
							<th>Сумма</th>
							<th>Кол-во</th>
							<th>Сумма</th>
							<th>Кол-во</th>
							<th>Сумма</th>
						</tr>
					</thead>
					<tr>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_remains_before_tmz_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_come_tmc_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_implemented_tmc_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
						<th></th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_transferred_to_metal_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_transferred_to_util_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
						<th></th>
						<th class="brl">
							{{
								illiquidReport.total_sum
									? illiquidReport.total_sum
											.total_remains_after_tmz_sum
									: 0 | getNumberFormatTmz
							}}
						</th>
					</tr>
					<tbody
						v-for="(request, index) in this.illiquidReportRequest"
						:key="request.id"
					>
						<tr>
							<td>{{ index + 1 }}</td>
							<td>{{ request.abp }}</td>
							<td>{{ request.category }}</td>
							<td>{{ request.code_tmc }}</td>
							<td>{{ request.name_tmc }}</td>
							<td>{{ request.measure_unit }}</td>
							<td v-if="!request.broken_years">
								{{
									request.remains_before_tmz_delivery_date
										| formatDateTwo
								}}
							</td>
							<td v-else>---</td>
<!--							<td :contenteditable="isEditableOnFifthStep(request.remains_before_tmz_count)" @blur="updateValue(request, 'remains_before_tmz_count', $event)">-->
							<td>
								{{
									request.remains_before_tmz_count
										| getNumberFormatTmz
								}}
							</td>
							<td :contenteditable="isEditableOnFifthStep(request.remains_before_tmz_price)" @blur="updateValue(request, 'remains_before_tmz_price', $event)" v-if="!request.broken_years">
								{{
									request.remains_before_tmz_price
										| getNumberFormatTmz
								}}
							</td>
							<td v-else>---</td>
							<td>
								{{
									request.remains_before_tmz_sum
										| getNumberFormatTmz
								}}
							</td>
							<td>
								{{ request.come_tmc_count | getNumberFormatTmz }}
							</td>
							<td>
								{{ request.come_tmc_sum | getNumberFormatTmz }}
							</td>
							<td>
								{{
									request.implemented_tmc_count
										| getNumberFormatTmz
								}}
							</td>
							<td>
								{{
									request.implemented_tmc_sum
										| getNumberFormatTmz
								}}
							</td>
							<td>{{ request.implemented_tmc_type }}</td>
							<td :contenteditable="isEditableOnSixthStep(request.transferred_to_metal_count)" @blur="updateValue(request, 'transferred_to_metal_count', $event)" v-if="!request.broken_years">
								{{
									request.transferred_to_metal_count
										| getNumberFormatTmz
								}}
							</td>
							<td :contenteditable="isEditableOnSixthStep(request.transferred_to_metal_sum)" @blur="updateValue(request, 'transferred_to_metal_sum', $event)" v-if="!request.broken_years">
								{{
									request.transferred_to_metal_sum
										| getNumberFormatTmz
								}}
							</td>
							<td :contenteditable="isEditableOnSixthStep(request.transferred_to_util_count)" @blur="updateValue(request, 'transferred_to_util_count', $event)" v-if="!request.broken_years">
								{{
									request.transferred_to_util_count
										| getNumberFormatTmz
								}}
							</td>
							<td :contenteditable="isEditableOnSixthStep(request.transferred_to_util_sum)" @blur="updateValue(request, 'transferred_to_util_sum', $event)" v-if="!request.broken_years">
								{{
									request.transferred_to_util_sum
										| getNumberFormatTmz
								}}
							</td>
							<td>
								{{
									request.remains_after_tmz_count
										| getNumberFormatTmz
								}}
							</td>
							<td>
								{{
									request.remains_after_tmz_sum
										| getNumberFormatTmz
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div v-else class="loading-container">
			Документ загружен, идет обработка...
			<div class="spinner">
				<div id="dot1" class="dot"></div>
				<div id="dot2" class="dot"></div>
				<div id="dot3" class="dot"></div>
				<div id="dot4" class="dot"></div>
				<div id="dot5" class="dot"></div>
			</div>
		</div>
	</div>
</template>

<script>
import StepHeader from '@/components/tmz/StepHeader';
import PageLoader from '@/components/PageLoader';
import EcpSign from '@/components/tmz/EcpSign';
import { isApproved, isImpl, isRecipient, isSaveChange } from '@/variables';
import { mapGetters } from 'vuex';
import { ModelSelect } from 'vue-search-select';
import { router } from '@/router';
import ImportFile from '@/components/ImportFile';
import store from '../../store';
import NProgress from 'nprogress';
import { month_options } from '@/variables';
import axios from 'axios';

export default {
	name: 'ViewIlliquidReportThree',
	components: {
		StepHeader,
		EcpSign,
		ModelSelect,
		PageLoader,
		ImportFile,
	},
	data() {
		return {
			codeTmc: '',
			selectedCodeTmc: '',
			tmcName: '',
			selectedTmcNaming: '',
			isApproved: false,
			isImpl: false,
			isRecipient: false,
			// tmzReport: {},
			// illiquidReport: {},
			// illiquidReportRequest: [],
			tmcCodes: [],
			tmcNamings: [],
			uploading: false,
			progress: 0,
			downloadInstructionTmz2ndStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/2_шаг.pdf`,
      downloadInstructionTmz3rdStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/3_шаг.pdf`,
      downloadInstructionTmz4thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/4_шаг.pdf`,
      downloadInstructionTmz5thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/5_шаг.pdf`,
      downloadInstructionTmz6thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/6_шаг.pdf`,
		};
	},
	watch: {
		codeTmc: function(value) {
			for (let i = 0; i < this.tmcCodesFilters.length; i++) {
				if (this.tmcCodesFilters[i].value == value) {
					this.selectedCodeTmc = this.tmcCodesFilters[i].text;
				}
			}
		},
		tmcName: function(value) {
			for (let i = 0; i < this.tmcNamingsFilters.length; i++) {
				if (this.tmcNamingsFilters[i].value == value) {
					this.selectedTmcNaming = this.tmcNamingsFilters[i].text;
				}
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getTmzReport', to.params.id).then(response => {
			store.dispatch('getIlliquidReportRequest', response);
			store.dispatch('getIlliquidReport', response);
			NProgress.done();
			next();
		});
	},
	methods: {
		updateValue(item, field, event) {
      const newValue = event.target.textContent;

      const payload = {
        id: item.id,
        key: field,
        value: newValue
      }
			
			axios.post(`tmz/edit_illiquid_tmz/`, payload).then((response) => {
        location.reload();
        console.log('response: ' + response.data);
      }).catch(e => {
        this.$store.dispatch('addNotification', {
            type: 'error',
            message: e.response.data,
        });
      })

      console.log(payload)
    },
		isEditableOnFifthStep(value) {
      if (this.TMZREPORT.step == 5) {
        return value !== '0';
      } else {
        return false;
      }
    },
		isEditableOnSixthStep(value) {
      if (this.TMZREPORT.step == 6) {
        return value !== '0';
      } else {
        return false;
      }
    },
		showInfoModal () {
			this.$modal.show('info-modal');
		},
		downloadUploadedFiles () {
      let id = this.illiquidReport.id;
      console.log(id)
      axios.get(`/tmz/illiquid/${id}/`).then((response) => {
        const firstFile = response.data.first_file_step_5
        const secondFile = response.data.second_file_step_6


				const getFileNameFromURL = (url) => {
          const decodedURL = decodeURIComponent(url);
          const matches = decodedURL.match(/\/([^\/?#]+)[^\/]*$/);
          return matches && matches[1];
        };

				if (firstFile) {
          const link = document.createElement('a')
          link.href = firstFile
          link.setAttribute('download', getFileNameFromURL(firstFile) || 'default_filename_5.txt');
          document.body.appendChild(link)
          link.click()
        }

        setTimeout(() => {
          if (secondFile) {
            const link = document.createElement('a')
            link.href = secondFile
						link.setAttribute('download', getFileNameFromURL(secondFile) || 'default_filename_6.txt');
            document.body.appendChild(link)
            link.click()
          }
        }, 1000)
        
			})
    },
    downloadTemplate (step) {
			let payload = {
				type: step
			}

			axios.get('/tmz/template-tmz/', {
				params: payload
			}).then((response) => {
				const url = response.data[0].file_data
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', response.data[0].file_name)
				document.body.appendChild(link)
				link.click()
			})
      // this.$store.tmz.downloadTemplate(step)
    },
		showMonth() {
			let monthName = this.TMZREPORT.month;

			return month_options.reduce((month, record) => {
				if (record.value == monthName) {
					monthName = record.name;
				}

				return monthName;
			}, 0);
		},
		clearFilters() {
			this.codeTmc = '';
			this.tmcName = '';
			this.selectedCodeTmc = '';
			this.selectedTmcNaming = '';
		},
		getFiltersData() {
			let payload = {
				reportId: this.$route.params.id,
				typeReport: 'illiquid',
			};
			this.$store.dispatch('getFiltersData', payload);
		},
		// getTmzReport() {
		//   this.$store.dispatch("getTmzReport", this.$route.params.id).then((response) => {
		//     this.tmzReport = response;
		//     this.getIlliquidReportRequest(this.tmzReport.illiquid);
		//     this.getIlliquidReport(this.tmzReport.illiquid);
		//   });
		// },
		getIlliquidReportRequest() {
			// if (!illiquidId) {
			// 	illiquidId = this.TMZREPORT.illiquid;
			// }
			let formData = {
				illiquid: this.TMZREPORT.illiquid,
				codeTmc: this.selectedCodeTmc,
				nameTmc: this.selectedTmcNaming,
			};
			this.$store
				.dispatch('getIlliquidReportRequest', formData)
				.then(response => {
					// this.illiquidReportRequest = response;

					for (let i = 0; i < response.length; i++) {
						this.tmcCodes.push({
							value: i,
							text: response[i].code_tmc,
						});
					}

					for (let i = 0; i < response.length; i++) {
						this.tmcNamings.push({
							value: i,
							text: response[i].name_tmc,
						});
					}
				});
		},
		// getIlliquidReport(liquidId) {
		//   this.$store.dispatch("getIlliquidReport", liquidId).then((response) => {
		//     this.illiquidReport = response;
		//   });
		// },
		toDate() {
			router.push({
				name: 'view-tmz-step-third-date',
				params: { id: this.$route.params.id },
			});
		},
	},
	created() {
		// this.getTmzReport();
		this.getFiltersData();
		this.isApproved = isApproved(this.USER.ouser);
		this.isImpl = isImpl(this.USER.ouser);
		this.isRecipient = isRecipient(this.USER.ouser);
	},
	mounted() {
		if (this.TMZREPORT.reload == 3) {
			let interval = setInterval(() => {
				this.$store
					.dispatch('getTmzReport', this.TMZREPORT.id)
					.then(response => {
						if (response.reload == 0) {
							this.$router.go();
						}
					});
			}, 5000);
		}
	},
	computed: {
		...mapGetters([
			'REPORT',
			'USER',
			'TMZREPORT',
			'tmzReport',
			'illiquidReport',
			'illiquidReportRequest',
			'tmcCodesFilters',
			'tmcNamingsFilters',
			'uploadProgress',
		]),
	},
};
</script>

<style scoped>
.table-container {
	/* overflow-x: auto; */
	padding: 0 2rem;
	min-width: 1800px;
	margin: 0 auto;
}

.table-container-inner {
	padding: 0.5rem;
	margin: 0 2rem;
	max-height: 65vh;
	overflow: auto;
	max-width: 100vw;
}

table {
	width: 100%;
	border-collapse: collapse;
	/* text-align: center; */
	margin: 0 auto 2rem;
	overflow-x: auto;
	border-bottom: 1px solid black;
	font-size: 14px;
}

.table-naming {
	font-size: 2rem;
	font-weight: bold;
	padding: 1rem 0;
	text-align: left;
}

.table-status {
	margin-bottom: 0.5rem;
}

th,
td {
	border: 1px solid #868686;
	padding: 0 1rem;
}

.expanded {
	padding: 0 2rem;
}

.table-specs {
	background: #36429e;
	width: 100px;
	height: 100px;
	color: white;
	text-align: center;
	border-top-left-radius: 10px;
	border: none;
	font-size: 1.5rem;
	vertical-align: bottom;
}

.table-actions {
	display: flex;
	padding: 2rem 0;
	justify-content: center;
}

.table-actions-button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-yellow {
	background: #ffbb56;
	color: white;
}

.btn-red {
	background: #e86363;
	color: white;
}

.btn-blue {
	background: #36429e;
	color: white;
}
.btn-upload-file {
	background: none;
	margin-left: -1rem;
}
.file-area {
	width: 100%;
	position: relative;
}

.file-area input[type='file'] {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	cursor: pointer;
	border-radius: 25px;
}

.file-area .file-state {
	width: 100%;
	padding: 1rem 1rem;

	border-radius: 10px;
	/* margin-left: 1rem; */
	cursor: pointer;
	font-size: 1.1rem;

	background: #5769f8;
	color: #fff;
	text-align: center;
	transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
	display: none;
}

.file-area:hover .file-state {
	background: rgba(255, 255, 255, 0.1);
	color: black !important;
}

.table-filter-container {
	margin: 1rem 0;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
}

.table-filter-select {
	max-width: 400px;
}

.table-filter-submit {
	/* width: 200px; */
	/* height: 60px; */
	padding: 0.5rem 1rem;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

/* *[data-tooltip] {
  position: relative;
}

*[data-tooltip]::after {
  content: attr(data-tooltip);

  position: absolute;
  top: 50px;
  right: -50px;
  width: 150px;

  pointer-events: none;
  opacity: 0;
  -webkit-transition: opacity 0.15s ease-in-out;
  -moz-transition: opacity 0.15s ease-in-out;
  -ms-transition: opacity 0.15s ease-in-out;
  -o-transition: opacity 0.15s ease-in-out;
  transition: opacity 0.15s ease-in-out;

  display: block;
  font-size: 12px;
  line-height: 16px;
  background: #fefdcd;
  padding: 2px 2px;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.4);
}

*[data-tooltip]:hover::after {
  opacity: 1;
} */
.brl {
	background-color: burlywood;
}

.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 2rem;
	min-height: 100vh;
}

ol li {
    list-style: decimal;
    list-style-position: inside;
}

.info-btn {
  float: right;
}

.sub-actions {
	padding-top: 2rem;
}
</style>
